import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroupSpacer} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {SameWidthButton} from '../../../../libs/shared/ui/src/components/buttons/sameWidthButton';
import {DialogButtonGroup} from '../../common/dialogs/dialogButtonGroup';
import {useContactDetailsContext} from '../contactDetailsContext';

/*
 * Styles.
 */

const StyledFooterContainerDiv = styled.div`
  background: ${(p) => p.theme.foreground};
  padding-top: 20px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

export const ContactMergeFooter: FC = () => {
  const contactDetailsContext = useContactDetailsContext();
  return (
    <StyledFooterContainerDiv>
      <DialogButtonGroup>
        <ButtonGroupSpacer />
        <SameWidthButton onClick={contactDetailsContext.mergeContext.cancelMerge}>
          <Trans id="contacts-merge-footer-cancel">Cancel</Trans>
        </SameWidthButton>
        <SameWidthButton
          variant={ButtonVariantsEnum.PRIMARY}
          onClick={contactDetailsContext.mergeContext.confirmMerge}
          interactionId="contact-details-merge-footer-merge-btn"
        >
          <Trans id="contacts-merge-footer-merge">Merge</Trans>
        </SameWidthButton>
      </DialogButtonGroup>
    </StyledFooterContainerDiv>
  );
};
